import { getTokenValue } from '@shinetools/sunshine';
import styled from 'styled-components';

import Text from 'components/_core/Text';

export const TransferSuccessText = styled(Text)`
  strong {
    color: ${getTokenValue('text-primary')};
  }
`;
